import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { ActionsEl } from "./Modal.styles";
import type { ModalActionsProps } from "./Modal.types";
import { useModalContext } from "./ModalContext";

const ModalActionsComponent = ({
  children,
  className,
  style,
}: ModalActionsProps): ReactElement => {
  const { basic } = useModalContext();
  return (
    <ActionsEl className={cx(className)} style={style} $basic={basic}>
      {children}
    </ActionsEl>
  );
};

export const ModalActions = styled(ModalActionsComponent)``;
